exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "eventroster #wrapper{min-height:calc(100% - 62px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/eventroster/eventroster.styl
// module id = 487
// module chunks = 0